import * as React from 'react';
import styles from './index.less';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import { AVATAR_URL_PREFIX } from '@/constants';
import FListFooter, { listStateAndListMore } from '@/components/FListFooter';
import FLoadingTip from '@/components/FLoadingTip';
import FNoDataTip from '@/components/FNoDataTip';
import FDrawer from '@/components/FDrawer';
import { PolicyFullInfo_Type } from '@/type/contractTypes';
import { DiscoverPageModelState } from '@/models/discoverPage';
import dayjs from 'dayjs';
import FResourceCard from '@/components/FResourceCard';

interface UserProps {
  search: string;
}

type ListType = {
  userID: number;
  userName: string;
  avatar: string;
  resourceCount: number;
}[];

function User({ search }: UserProps) {

  const [$search, set$search, get$search] = FUtil.Hook.useGetState<string>('');
  const [$dataSource, set$dataSource, get$dataSource] = FUtil.Hook.useGetState<ListType>([]);
  const [$totalItem, set$totalItem, get$totalItem] = FUtil.Hook.useGetState<number>(-1);
  const [$state, set$state, get$state] = FUtil.Hook.useGetState<'loading' | 'noData' | 'noSearchResult' | 'loaded'>('loading');
  const [$more, set$more, get$more] = FUtil.Hook.useGetState<'loading' | 'andMore' | 'noMore'>('loading');

  const [$userInfo, set$userInfo, get$$userInfo] = FUtil.Hook.useGetState<{
    userID: number;
    avatar: string;
    username: string;
    resourceCount: number;
  } | null>(null);

  AHooks.useDebounceEffect(() => {
    handle(true);
  }, [search], {
    wait: 300,
  });

  async function handle(restart: boolean = false) {
    // console.log(search, 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS');
    let oldList: ListType = [];

    if (!restart) {
      oldList = get$dataSource();
      set$more('loading');
    } else {
      set$state('loading');
    }

    const { data: data_users }: {
      data: {
        dataList: {
          headImage: string;
          latestLoginDate: string;
          resourceCount: number;
          userId: number;
          username: string;
        }[];
        totalItem: number;
      }
    } = await FServiceAPI.User.searchForConsole({
      keywords: search,
      skip: oldList.length,
      limit: FUtil.Predefined.pageSize,
    });

    // let userCount: {
    //   createdResourceCount: number;
    //   userId: number;
    // }[] = [];
    // if (data_users.dataList.length > 0) {
    //   const { data: data_count }: {
    //     data: {
    //       createdResourceCount: number;
    //       userId: number;
    //     }[];
    //   } = await FServiceAPI.Resource.resourcesCount({
    //     userIds: data_users.dataList.map((u) => {
    //       return u.userId;
    //     }).join(','),
    //     status: 1,
    //   });
    //   userCount = data_count;
    //   // console.log(data_count, 'data_count oisdjflkjsdlkfjlksdjfkljklj');
    // }


    const list: ListType = [
      ...oldList,
      ...data_users.dataList.map((u) => {
        // const count: number = userCount.find((uc) => {
        //   return uc.userId === u.userId;
        // })?.createdResourceCount || 0;

        return {
          userID: u.userId,
          userName: u.username,
          avatar: u.headImage,
          resourceCount: u.resourceCount,
        };
      }),
    ];

    const { state, more } = listStateAndListMore({
      list_Length: list.length,
      total_Length: data_users.totalItem,
      has_FilterCriteria: search !== '',
    });

    set$search(search);
    set$dataSource(list);
    set$totalItem(data_users.totalItem);
    set$state(state);
    set$more(more);
    // console.log(data_users, 'data_users osidjflksdjflkjsdlkjfkljlk');
  }

  if ($state === 'loading') {
    return (<FLoadingTip height={600} />);
  }

  if ($state === 'noData') {
    return (<FNoDataTip
      height={600}
      tipText={'无数据'}
    />);
  }

  if ($state === 'noSearchResult') {
    return (<FNoDataTip
      height={600}
      tipText={`抱歉，没有找到与${$search}相关的结果`}
    />);
  }

  return (<>
    <div className={styles.styles}>
      <div style={{ height: 30 }} />
      {
        $search !== '' && (<>
          <FComponentsLib.FContentText
            type={'normal'}
            text={`以下是${$search}相关的结果（${$totalItem}）`}
            style={{
              color: '#999',
            }}
          />
          <div style={{ height: 40 }} />
        </>)
      }

      <div className={styles.userList}>
        {
          $dataSource.map((u) => {
            return (<div
              className={styles.card}
              key={u.userID}
              onClick={() => {
                // set$userID(u.userID);
                set$userInfo({
                  userID: u.userID,
                  username: u.userName,
                  resourceCount: u.resourceCount,
                  avatar: u.avatar,
                });
              }}
            >
              <img
                src={u.avatar}
                className={styles.avatar}
                alt={''}
              />
              <div>
                <FComponentsLib.FTitleText type={'h3'} text={u.userName} />
                <div style={{ height: 10 }} />
                <FComponentsLib.FContentText
                  type={'normal'}
                  text={`已上架${u.resourceCount}个资源`}
                  style={{ color: '#2784FF' }}
                />
              </div>
            </div>);
          })
        }

        {/*<div style={{ width: 450 }} />*/}
      </div>

      <div style={{ height: 100 }} />

      <FListFooter
        state={$more}
        onClickLoadMore={() => {
          handle(false);
        }}
      />
      <div style={{ height: 100 }} />

    </div>

    <UserResourceDrawer
      userInfo={$userInfo}
      onClose={() => {
        // set$userID(-1);
        set$userInfo(null);
      }}
    />
  </>);
}

export default User;

interface UserResourceDrawerProps {
  // userID: number;
  userInfo: {
    userID: number;
    avatar: string;
    username: string;
    resourceCount: number;
  } | null;

  onClose?(): void;
}

type ResourceListType = {
  id: string;
  cover: string;
  name: string;
  title: string;
  version: string;
  policy: string[];
  type: string[];
  status: 0 | 1 | 2 | 4;
  authProblem?: boolean;
  updateDate: string;
  username: string;
  useAvatar: string;
  isChoice: boolean;
  collection?: {
    status: 'finish' | 'unFinish';
    count: number;
  } | null;
}[]

function UserResourceDrawer({ userInfo, onClose }: UserResourceDrawerProps) {

  // const [$userInfo, set$userInfo, get$userInfo] = FUtil.Hook.useGetState<null | {
  //   avatar: string;
  //   username: string;
  //   resourceCount: number;
  // }>(null);

  const [$dataSource, set$dataSource, get$dataSource] = FUtil.Hook.useGetState<ResourceListType>([]);
  const [$totalItem, set$totalItem, get$totalItem] = FUtil.Hook.useGetState<number>(-1);
  const [$state, set$state, get$state] = FUtil.Hook.useGetState<'loading' | 'noData' | 'noSearchResult' | 'loaded'>('loading');
  const [$more, set$more, get$more] = FUtil.Hook.useGetState<'loading' | 'andMore' | 'noMore'>('loading');


  async function handle(restart: boolean = false) {

    let oldList: ResourceListType = [];

    if (!restart) {
      oldList = get$dataSource();
      set$more('loading');
    } else {
      set$state('loading');
    }

    // const selectedOperationCategoryIDs: string[] = get$selectedOperationCategoryIDs().filter((c) => {
    //   return c !== '#all';
    // });

    const params: Parameters<typeof FServiceAPI.Resource.list>[0] = {
      skip: oldList.length,
      limit: FUtil.Predefined.pageSize,
      status: 1,
      userId: userInfo?.userID || -1,
    };

    const { data: data_resources }: {
      data: {
        dataList: {
          resourceId: string;
          coverImages: string[];
          resourceName: string;
          resourceTitle: string;
          resourceType: string[];
          updateDate: string;
          status: 0 | 1 | 2 | 4;
          latestVersion: string;
          policies: PolicyFullInfo_Type[];
          // updateDate: string;
          username: string;
          userId: number;
          operationType: 0 | 1 | 2 | 3 | 4 | 5;
          serializeStatus: 0 | 1;
          subjectType: 1 | 4;
          resourceVersions: {
            versionId: string;
          }[];
        }[];
        totalItem: number;
      };
    } = await FServiceAPI.Resource.list(params);

    const params2: Parameters<typeof FServiceAPI.Resource.getVersionList>[0] = {
      versionIds: data_resources.dataList.filter((bi) => {
        return bi.subjectType === 4;
      }).map((bi) => {
        return bi.resourceVersions[0].versionId;
      }).join(','),
    };
    const { data: data_versionList }: {
      data: {
        resourceId: string;
        catalogueProperty: { collection_item_count: number };
      }[];
    } = await FServiceAPI.Resource.getVersionList(params2);

    const list: ResourceListType = [
      ...oldList,
      ...data_resources.dataList
        // .filter((i) => {
        //   return !existentResourceIDs.includes(i.resourceId);
        // })
        .map<DiscoverPageModelState['dataSource'][number]>((i) => {
          // console.log(i, 'i#@@#$@#$@#$@#$@#4234098ijosfdlksd');
          const resourceVersionInfo = data_versionList.find((vl) => {
            return vl.resourceId === i.resourceId;
          });
          return {
            id: i.resourceId,
            cover: i.coverImages.length > 0 ? i.coverImages[0] : '',
            name: i.resourceName,
            title: i.resourceTitle,
            version: i.latestVersion,
            policy: i.policies
              .filter((l) => {
                return l.status === 1;
              })
              .map((l) => l.policyName),
            type: i.resourceType,
            status: 1,
            updateDate: dayjs(i.updateDate).format(FUtil.Predefined.momentDateFormat),
            username: i.username,
            useAvatar: `${AVATAR_URL_PREFIX}${i.userId}`,
            isChoice: i.operationType === 5,
            collection: (i.subjectType === 4 && !!resourceVersionInfo)
              ? {
                status: i.serializeStatus === 1 ? 'finish' : 'unFinish',
                count: resourceVersionInfo.catalogueProperty.collection_item_count,
              }
              : null,
          };
        }),
    ];

    const { state, more } = listStateAndListMore({
      list_Length: list.length,
      total_Length: data_resources.totalItem,
      has_FilterCriteria: false,
    });

    set$dataSource(list);
    set$state(state);
    // set$state('noData');
    set$more(more);
    set$totalItem(data_resources.totalItem);
  }

  return (<FDrawer
    // title={'资源列表'}
    title={userInfo && (<div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={userInfo.avatar}
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
        }}
        alt={''}
      />
      <div style={{ width: 10 }} />
      <FComponentsLib.FContentText
        text={userInfo.username}
        type={'highlight'}
      />
      <div style={{ width: 20 }} />
      {
        $totalItem !== -1 && (<FComponentsLib.FContentText
          // text={`上架的资源（${userInfo.resourceCount}）`}
          text={`上架的资源（${$totalItem}）`}
          type={'normal'}
          style={{ color: '#999' }}
        />)
      }

    </div>)}
    width={'100%'}
    open={!!userInfo}
    afterOpenChange={async (o) => {
      if (o) {
        handle(true);


        // const { data: data_user }: {
        //   data: {
        //     headImage: string;
        //     userId: number;
        //     username: string;
        //   }
        // } = await FServiceAPI.User.userDetails({
        //   userId: userInfo.userID,
        // });
        //
        // const { data: data_count }: {
        //   data: {
        //     createdResourceCount: number;
        //     userId: number;
        //   }[];
        // } = await FServiceAPI.Resource.resourcesCount({
        //   userIds: String(userID),
        //   status: 1,
        // });
        //
        // set$userInfo({
        //   username: data_user.username,
        //   avatar: data_user.headImage,
        //   resourceCount: data_count[0]?.createdResourceCount ?? -1,
        // });
      } else {
        set$state('loading');
        // set$userInfo(null);
        set$totalItem(-1);
      }
    }}
    onClose={onClose}
  >
    <>
      {
        $state === 'noData' && (<FNoDataTip height={600} tipText={'无数据'} />)
      }

      <div
        className={styles.resourceStyles}
        style={{
          display: $state !== 'noData' ? 'block' : 'none',
        }}
      >
        {
          $state === 'loading' && (<div style={{
            width: 1540,
            // display: 'flex',
            // alignItems
          }}>
            <FLoadingTip height={600} />
          </div>)
        }


        {
          $state === 'loaded' && (<>
            <div style={{ height: 10 }} />
            <div className={styles.Content}>
              {$dataSource.map((resource) => (
                <FResourceCard
                  key={resource.id}
                  resource={resource}
                  onClick={() => {
                    if (resource.collection) {
                      window.open(
                        FUtil.LinkTo.collectionDetails({
                          collectionID: resource.id,
                        }),
                      );
                    } else {
                      window.open(
                        FUtil.LinkTo.resourceDetails({
                          resourceID: resource.id,
                        }),
                      );
                    }
                  }}
                />
              ))}
            </div>

            <div style={{ height: 100 }} />

            <FListFooter
              state={$more}
              onClickLoadMore={() => {
                handle(false);
              }}
            />

            <div style={{ height: 100 }} />
          </>)
        }

      </div>
    </>
  </FDrawer>);
}
